import type { RouteObject } from 'react-router-dom';
import { paths } from '@/router/paths';
import { SalesOrderListPage } from './SalesOrderListPage';
import { SalesOrderCreatePage } from './SalesOrderCreatePage';
import { SalesOrderDetailPage } from './SalesOrderDetailPage';

export const salesOrderRoutes: RouteObject[] = [
  { path: paths.salesOrders, element: <SalesOrderListPage /> },
  { path: paths.salesOrderCreate, element: <SalesOrderCreatePage /> },
  { path: paths.salesOrderDetail, element: <SalesOrderDetailPage /> }
];
